import RootStore from '../components/models';

export default function initStore() {
    const appDataEl = document.getElementById('app-data');
    let appData = {};

    const appDataRaw = appDataEl?.textContent;
    if (!(appDataRaw === undefined)) {
        appData = JSON.parse(appDataRaw);
    }

    // we don't want the app data sticking around, cluttering the DOM
    if (!(appDataEl == null)) {
        appDataEl.parentNode.removeChild(appDataEl);
    }

    return new RootStore({ ...appData });
}
